import { TPaginationSettings } from '../../lib/interfaces/Pagination';
import { API_METHODS, BASE_URL, createHeader } from '../endpointBuilder';
import { axiosRequest } from '../request';

const endpoints = {
	getCwTrainingEmails: (pagination?: TPaginationSettings | null) => {
		let url = `${BASE_URL}/cw-training-email`;
		if (pagination) {
			const { page, limit } = pagination;
			url = `${BASE_URL}/cw-training-email?page=${page}&limit=${limit}`;
		}
		return {
			headers: createHeader(null, true),
			url,
			method: API_METHODS.GET,
		};
	},
	markAsReadCwTrainingEmail: (emailId: number) => ({
		headers: createHeader(null, true),
		url: `${BASE_URL}/cw-training-email/${emailId}/read`,
		method: API_METHODS.PATCH,
	}),
};

export const getCwTrainingEmails = async (
	pagination: TPaginationSettings | null,
) => axiosRequest(endpoints.getCwTrainingEmails(pagination));

export const markAsReadCwTrainingEmail = async (id: number) =>
	axiosRequest(endpoints.markAsReadCwTrainingEmail(id));
